import {
	Stack,
} from '@mui/material'
import {
	forwardRef,
} from 'react'

import type {
	StackProps,
} from '../stack/stack.types'

const HStack = forwardRef<HTMLDivElement, StackProps>((
	props,
	ref,
) => {
	const {
		children,
		spacing = 1,
		...other
	} = props

	return (
		<Stack
			ref={ref}
			direction='row'
			spacing={spacing}
			{...other}
		>
			{children}
		</Stack>
	)
})

export default HStack
